<template>
    <div>
      <div class="d-flex justify-content-between align-item-center mb-3">
        <div class="section-title mb-3">
          {{ $t("edit") }} {{ $tc("Fnb Station", 2) }}
        </div>
     
      </div>
      <div class="white-wrapper">
        <div class="row">
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                station_name
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("Station") }} {{ $tc("Name", 1) }}</label
              >
              <input
                                required
                                type="search"
                                placeholder=""
                                class="form-control form-control-md"
                          
                                v-model="station_name"
                              />
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  delivery_percentage 
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("Delivery") }} {{ $tc("Percentage", 1) }}</label
              >
              <input
                                required
                                type="search"
                                placeholder=""
                                class="form-control form-control-md"
                          
                                v-model="delivery_percentage"
                              />
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  delivery_percentage 
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("Report") }} {{ $tc("Code", 1) }}</label
              >
              <input
                                required
                                type="search"
                                placeholder=""
                                class="form-control form-control-md"
                          
                                v-model="report_code"
                              />
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class=" d-flex align-items-center ">
            <input type="checkbox" style="width: 15px; height:15px" name="" id="" v-model="station_is_active">
            <span class="ml-2">{{ station_is_active?"active":"inactive" }}</span>
            </div>
           
          </div>
        </div>
        <div class="row d-flex justify-content-between">

        </div>
        <div class="text-center">
        <button @click.prevent.stop="onSubmit()" class="btn-blue">
          {{ $t("save") }}
        </button>
      </div>
      
      </div>
  

  
    
    </div>
  </template>
  
  <script>
    import MasterService from "@/services/MasterService";
    import MovieService from "@/services/MovieService";
    import Cinemas from "@/helper/formJSONMaster/Cinemas";
    import CinemaService from "@/services/CinemasService";
    import VueCropper from "vue-cropperjs";
    import "cropperjs/dist/cropper.css";
    import ExhibitorService from "@/services/ExhibitorService";
  
    export default {
      components: { VueCropper },
      data() {
        return {
         
          data:{},
          station_id:null,
          station_name:"",
          delivery_percentage:null,
          station_is_active:true,
          report_code:null,
          gl_account:null,
          gl_desc:null,
          gl_account_item:null

        };
      },
      beforeMount() {
        const { station_id } = this.$route.query;
        if (station_id) {
    this.station_id=station_id
    this.getfnbstationData()
        } else {
          this.$router.go(-1);
        }
      },
      mounted() {},
      methods: {
    
      
    OnSwitchHandler: function (event) {
      this.station_is_active = event;
    },
    getfnbstationData:function(){
        let payload={
            station_id:this.station_id
        }
        let loader = this.$loading.show();
        MasterService.getFnbStations(payload)
          .then((response) => {
            const { data } = response;
            console.log("data",data.Records)
            if (data.status && data.Records.length > 0) {
                let obj=data.Records[0]
                this.data=data.Records[0]
                console.log("data",data.Records)

                obj.station_name && (this.station_name=obj.station_name);
                obj.delivery_percentage &&( this.delivery_percentage=obj.delivery_percentage)
                obj.report_code && (this.report_code=obj.report_code)
                obj.station_is_active && (this.station_is_active=obj.station_is_active=="Y"?true:false)
              
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide()
          })
          .catch(this._CatchError)
          .finally(() => {
            loader.hide()
        }); 
        
        },
        onSubmit:function(){
            if(!this.station_name){
             return  this.$toasted.show("station name is required");
            }
            if(!this.delivery_percentage){
             return  this.$toasted.show("delivery percentage is required");
            }
            let payload={};
            this.station_name && (payload.station_name=this.station_name)
            this.delivery_percentage && (payload.delivery_percentage=this.delivery_percentage)
            this.report_code && (payload.report_code=this.report_code);
           payload.station_is_active=this.station_is_active?"Y":"N"
            payload.station_id=this.data.station_id
            let loader = this.$loading.show();
console.log("payload",this.station_is_active,payload)
            MasterService.addUpdateFnbStation(payload)
          .then((response) => {
            const { data } = response;
            console.log("data",data.Records)
            if (data.status) {
          
                // this.$toasted.show(data.message);
                this.$router.go(-1);

            } else {
              this.$toasted.show(data.message);
            }
            loader.hide()
          })
          .catch(this._CatchError)
          .finally(() => {
            loader.hide()
        }); 

        }
  
      
       
      
     
  
       
      
     
      
      
        
       
  
      
      },
    };
  </script>
  
  <style>
    #imagecropper .btn-clearDate {
      margin-top: -10px;
      margin-right: -10px;
      font-size: 19px;
    }
  
    .translationContainer {
      background: rgba(211, 211, 211, 0.2);
      border-radius: 10px;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnbStations/editFnbStations.vue